/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Criteria } from './Criteria';
import {
    CriteriaFromJSON,
    CriteriaFromJSONTyped,
    CriteriaToJSON,
} from './Criteria';

/**
 * 
 * @export
 * @interface BulkUpdateCriteriaRequest
 */
export interface BulkUpdateCriteriaRequest {
    /**
     * 
     * @type {Criteria}
     * @memberof BulkUpdateCriteriaRequest
     */
    criterion: Criteria;
}

/**
 * Check if a given object implements the BulkUpdateCriteriaRequest interface.
 */
export function instanceOfBulkUpdateCriteriaRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "criterion" in value;

    return isInstance;
}

export function BulkUpdateCriteriaRequestFromJSON(json: any): BulkUpdateCriteriaRequest {
    return BulkUpdateCriteriaRequestFromJSONTyped(json, false);
}

export function BulkUpdateCriteriaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateCriteriaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criterion': CriteriaFromJSON(json['criterion']),
    };
}

export function BulkUpdateCriteriaRequestToJSON(value?: BulkUpdateCriteriaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criterion': CriteriaToJSON(value.criterion),
    };
}

